import styled from 'styled-components'
import { colors } from '../../styles'

export const StyledTag = styled.button`
  color: ${colors.white};
  background-color: ${colors.red};
  font-size: 12px;
  font-weight: bold;
  padding: 6px 4px;
  display: inline-block;
  height: fit-content;
  margin-left: 8px;
  border: none;
`
